/* Modern Scandinavia — Byt delar i rumspaket + Ditt rum-vy
   Paketet laggs i varukorgen som sina delar (paketpris = summan av delarnas priser).
   Data: assets/ms-swap-data.js (window.MS_SW). Live pris/lager hamtas fran /products/<handle>.js */
(function () {
  var D = window.MS_SW, root = document.querySelector('.pk-inneh[data-swap]');
  if (!D || !root) return;
  var ON = (root.getAttribute('data-swap') || '').split(',');
  if (ON.indexOf('all') < 0 && ON.indexOf(root.getAttribute('data-handle')) < 0) return;

  var MONT = window.MS_MONT || {};
  var form = document.querySelector('form[data-type="add-to-cart-form"][id^="product-form-template"]');
  if (!form) return;
  var vidInput = form.querySelector('input.product-variant-id');
  var btn = form.querySelector('button[name="add"]');
  var priceEl = document.querySelector('[id^="ProductPrice-template"]');
  var CAT = { soffa: 'soffa', fatolj: 'fåtölj', soffbord: 'soffbord', sidobord: 'sidobord', matbord: 'matbord', matstol: 'stolar',
    golvlampa: 'golvlampa', taklampa: 'taklampa', bordslampa: 'bordslampa', forvaring: 'förvaring', vagghylla: 'vägghylla' };
  var MAX_ALT = 6, SOFA_TOL = 40;

  var cache = {};
  function prod(code) {
    var h = D.parts[code].h;
    if (!cache[h]) cache[h] = fetch('/products/' + h + '.js').then(function (r) { if (!r.ok) throw r.status; return r.json(); });
    return cache[h];
  }
  function variantOf(p, id) { for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === id) return p.variants[i]; return null; }
  function kr(cents) { return Math.round(cents / 100).toLocaleString('en-US') + ' kr'; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function chairsFor(L) { return L < 200 ? 4 : (L < 280 ? 6 : 8); }
  function img(src, w) { if (!src) return ''; src = src.replace(/^\/\//, 'https://'); return src + (src.indexOf('?') > 0 ? '&' : '?') + 'width=' + w; }

  // ---------- state ----------
  var curVid = null, pkg = null, slots = [], info = {}, notes = {}, sid = 0; // info[code] = product json
  function load(vid) {
    curVid = String(vid); pkg = D.pkgs[curVid]; notes = {};
    if (!pkg) { slots = []; render(); return; }
    slots = pkg.s.map(function (s) { return { id: 's' + (++sid), c: s[0], q: s[1], v: s[2], oc: s[0], oq: s[1], ov: s[2] }; });
    Promise.all(slots.map(function (s) { return prod(s.c).then(function (p) { info[s.c] = p; }); })).then(render, render);
    render();
    if (editId && !restored) { restored = true; restore(); }
  }
  // "Byt delar" i varukorgen: bygg tillbaka de valda delarna och oppna 3D-vyn
  var editId = (new URLSearchParams(location.search)).get('ms_edit'), restored = false;
  function restore() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var its = cart.items.filter(function (it) { var p = it.properties; return p && p._pkg === editId && p._c && D.parts[p._c]; });
      if (!its.length) return;
      its.sort(function (a, b) { return +a.properties._slot - +b.properties._slot; });
      slots = its.map(function (it) {
        var p = it.properties, o = { id: 's' + (++sid), c: p._c, q: it.quantity, v: it.variant_id, oc: p._oc && D.parts[p._oc] ? p._oc : p._c, ov: +p._ov || it.variant_id, oq: +p._oq || it.quantity };
        if (p._add === '1') o.add = true;
        return o;
      });
      var need = {}; slots.forEach(function (s) { need[s.c] = 1; need[s.oc] = 1; });
      Promise.all(Object.keys(need).map(function (c) { return prod(c).then(function (p) { info[c] = p; }, function () { }); })).then(function () {
        render();
        var n = 0, t = setInterval(function () { if (window.msOpen3d && window.msRum3d) { clearInterval(t); window.msOpen3d(); } else if (++n > 60) clearInterval(t); }, 200);
      });
    });
  }
  function slotOf(cat) { for (var i = 0; i < slots.length; i++) if (D.parts[slots[i].c].c === cat) return slots[i]; return null; }
  function chairCount(s) { return s.q * (D.parts[s.c].pk || 1); }
  function origChairs() { var s = slotOf('matstol'); return s ? s.oq * (D.parts[s.oc].pk || 1) : 0; }
  function modified() { return !pkg || slots.length !== pkg.s.length || slots.some(function (s) { return s.add || s.c !== s.oc || s.q !== s.oq || s.v !== s.ov; }); }
  function total() {
    var t = 0, ok = true;
    slots.forEach(function (s) { var p = info[s.c], v = p && variantOf(p, s.v); if (v) t += v.price * s.q; else ok = false; });
    return ok ? t : null;
  }
  function allAvailable() {
    return slots.every(function (s) { var p = info[s.c], v = p && variantOf(p, s.v); return v && v.available; });
  }

  // ---------- UI-skal ----------
  root.querySelectorAll('.pk-list').forEach(function (l) { l.setAttribute('data-hide', '1'); });
  var box = document.createElement('div');
  box.className = 'ms-sw';
  box.innerHTML = '<div class="ms-room-wrap"><p class="ms-room-ttl">Ditt rum <span>– uppdateras när du byter</span></p><div class="ms-room"></div>' +
    '<p class="ms-room-note" hidden>Bilderna högst upp visar originalpaketet. Ditt rum visar dina val. <button type="button" class="ms-reset">Återställ paketet</button></p></div>' +
    '<div class="ms-list"></div>';
  root.querySelector('.pk-ttl').insertAdjacentElement('afterend', box);
  // Ditt rum under huvudbilderna pa dator, i listan pa mobil
  var gal = document.querySelector('.pr_photoes'), roomWrap = box.querySelector('.ms-room-wrap');
  function placeRoom() {
    var lg = document.querySelector('.pr_lg_img');
    var want = (window.innerWidth >= 768 && gal) ? gal : box;
    if (roomWrap.parentNode !== want) { if (want === gal) gal.appendChild(roomWrap); else box.insertBefore(roomWrap, box.firstChild); }
    if (want === gal && lg) { roomWrap.style.width = lg.offsetWidth + 'px'; roomWrap.style.marginLeft = 'auto'; roomWrap.style.marginTop = '24px'; }
    else { roomWrap.style.width = ''; roomWrap.style.marginLeft = ''; roomWrap.style.marginTop = ''; }
  }
  placeRoom(); roomWrap.style.display = 'none';
  var roomEl = roomWrap.querySelector('.ms-room'), listEl = box.querySelector('.ms-list'), noteEl = roomWrap.querySelector('.ms-room-note');
  var pop = document.createElement('div');
  pop.className = 'ms-pop'; pop.innerHTML = '<div class="ms-pop-box" role="dialog" aria-modal="true"><button type="button" class="ms-x" aria-label="Stäng">&times;</button><div class="ms-pop-body"></div></div>';
  document.body.appendChild(pop);
  var popBody = pop.querySelector('.ms-pop-body');
  function openPop(html) { popBody.innerHTML = html; pop.classList.add('open'); }
  function closePop() { pop.classList.remove('open'); }
  pop.addEventListener('click', function (e) { if (e.target === pop || e.target.closest('.ms-x') || e.target.closest('[data-close]')) closePop(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePop(); });

  // ---------- lista ----------
  var listeners = [];
  function render() {
    renderList(); renderRoom(); renderPrice();
    noteEl.hidden = !modified();
    listeners.forEach(function (f) { try { f(); } catch (e) { } });
  }
  function renderList() {
    var t = slots.map(function (s, i) {
      var part = D.parts[s.c], p = info[s.c], v = p && variantOf(p, s.v);
      var title = p ? p.title + (p.variants.length > 1 && v ? ' – ' + v.title : '') : '…';
      var qty = part.c === 'matstol' ? ' × ' + s.q + (part.pk > 1 ? ' (' + chairCount(s) + ' stolar)' : '') : (s.q > 1 ? ' × ' + s.q : '');
      var out = v && !v.available ? '<span class="ms-out">Slut i lager – byt till ett alternativ</span>' : '';
      var changed = s.add ? '<span class="ms-tag">Tillagd</span>' : ((s.c !== s.oc || s.v !== s.ov) ? '<span class="ms-tag">Bytt</span>' : '');
      var row = '<div class="ms-row" data-i="' + i + '"><button type="button" class="ms-info" data-i="' + i + '">' +
        (p && p.featured_image ? '<img src="' + img(p.featured_image, 160) + '" alt="" loading="lazy">' : '<span class="ms-ph"></span>') +
        '<span class="ms-t">' + esc(title) + qty + changed + out + '<small>' + (v ? kr(v.price * s.q) : '') + '</small></span></button>' +
        '</div>';
      if (part.c === 'matstol') {
        var tb = slotOf('matbord');
        if (tb && tb.c !== tb.oc) {
          var need = chairsFor(D.parts[tb.c].L), have = chairCount(s), add = need - have;
          if (add > 0) row += '<p class="ms-hint">Rekommenderat: ' + need + ' stolar för det här bordet. <button type="button" class="ms-addch" data-n="' + add + '">+ Lägg till ' + add + '</button></p>';
        }
      }
      return row;
    }).join('');
    if (modified()) t += '<button type="button" class="ms-reset ms-reset-btn btn">Återställ paketet</button>';
    listEl.innerHTML = t;
  }
  function renderPrice() {
    var t = total();
    if (priceEl && t !== null && priceEl.textContent.trim() !== kr(t)) priceEl.textContent = kr(t);
    if (btn) {
      var ok = t !== null && slots.length > 0 && allAvailable();
      btn.disabled = !ok;
      btn.classList.toggle('ms-btn-off', !ok);
      var tx = btn.querySelector('.txt');
      var miss = slots.filter(function (s) { var p = info[s.c], v = p && variantOf(p, s.v); return v && !v.available; }).length;
      if (tx) {
        if (miss) {
          if (btn.getAttribute('data-ms-o') === null) btn.setAttribute('data-ms-o', tx.textContent);
          var m = miss + (miss === 1 ? ' del saknas' : ' delar saknas');
          if (tx.textContent !== m) tx.textContent = m;
        } else if (btn.getAttribute('data-ms-o') !== null) { tx.textContent = btn.getAttribute('data-ms-o'); btn.removeAttribute('data-ms-o'); }
      }
      var sl = document.querySelector('.product-stock .stockLbl');
      if (sl) {
        if (miss) {
          if (sl.getAttribute('data-ms-o') === null) sl.setAttribute('data-ms-o', sl.textContent);
          var m2 = miss + (miss === 1 ? ' del saknas' : ' delar saknas') + '. Var god redigera rum';
          if (sl.textContent !== m2) sl.textContent = m2;
        } else if (sl.getAttribute('data-ms-o') !== null) { sl.textContent = sl.getAttribute('data-ms-o'); sl.removeAttribute('data-ms-o'); }
      }
    }
  }

  // ---------- Ditt rum ----------
  var ROOM_CM = { V: 440, M: 370, K: 780 };
  // x = mitt i % av zonen, b = underkant i % av rummets hojd, z = lager, d = djupskala (langre bak = mindre)
  var POS = {
    V: { soffa: [50, 37, 3, .86], sidobord: [50, 37, 3, .86], golvlampa: [50, 38, 2, .84], fatolj: [81, 7, 6, 1], soffbord: [50, 9, 7, 1], taklampa: [50, -1, 8, 1],
      forvaring: [86, 39, 1, .78], vagghylla: [14, 64, 1, .78], bordslampa: [86, 0, 2, .78] },
    M: { matbord: [50, 14, 4, .95], taklampa: [50, -1, 8, 1], forvaring: [78, 39, 1, .74], vagghylla: [20, 64, 1, .74], golvlampa: [10, 38, 2, .8], bordslampa: [78, 0, 2, .74] }
  };
  var ASSET = window.MS_ASSET || '';
  function cutUrl(code) { return ASSET.replace('msc-00.webp', 'msc-' + code + '.webp'); }
  function place(code, zone, x0, w0, scale, H, cat, extra) {
    var part = D.parts[code];
    if (!part) return '';
    extra = extra || {};
    var pos = POS[zone][cat] || [50, 20, 2, 1], d = extra.d || pos[3], ar = part.ar || 1;
    // utklippt bild ar beskuren till mobeln: storlek fran verkliga matt (bredd eller hojd, det storsta)
    // ryms inom verklig bredd och hojd (med lite marginal for snett fotograferade bilder)
    var k = scale * d, tall = part.dh > part.dw;
    var wmax = part.dw * k * (tall ? 1.15 : 1), hmax = part.dh * k * (tall ? 1 : 1.15);
    var wpx = Math.min(wmax, hmax * ar), hpx = wpx / ar;
    var x = x0 + w0 * pos[0] / 100 + (extra.dx || 0) * scale;
    var st = 'width:' + wpx + 'px;height:' + hpx + 'px;left:' + (x - wpx / 2) + 'px;z-index:' + (extra.z || pos[2]) + ';';
    var cord = '';
    if (pos[1] < 0) { var drop = H * 0.13; st += 'top:' + drop + 'px;'; cord = '<span class="ms-cord" style="left:' + x + 'px;height:' + (drop + 2) + 'px;z-index:' + (extra.z || pos[2]) + '"></span>'; }
    else st += 'bottom:' + ((extra.b !== undefined ? extra.b : pos[1]) / 100 * H) + 'px;';
    return cord + '<img class="ms-it" src="' + cutUrl(code) + '" alt="" style="' + st + '">';
  }
  // ---------- Ditt rum i 3D (three.js) ----------
  // Rum och mobler som riktiga 3D-modeller, byggda fran matt (cm), form och farger per del. Kan vridas runt.
  var R3 = null, THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  function renderGrid() {
    roomEl.classList.add('ms-room-grid');
    roomEl.innerHTML = slots.map(function (s) {
      return '<figure class="ms-tile"><span class="ms-tile-img"><img src="' + cutUrl(s.c) + '" alt="" loading="lazy"></span></figure>';
    }).join('');
  }
  function loadThree(cb) {
    if (window.THREE) return cb();
    if (loadThree.wait) { loadThree.wait.push(cb); return; }
    loadThree.wait = [cb];
    var sc = document.createElement('script');
    sc.src = THREE_URL;
    sc.onload = function () { loadThree.wait.forEach(function (f) { f(); }); };
    sc.onerror = function () { R3 = false; renderGrid(); };
    document.head.appendChild(sc);
  }
  function canvasTex(w, h, paint) {
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    paint(c.getContext('2d'), w, h);
    var t = new THREE.CanvasTexture(c); t.encoding = THREE.sRGBEncoding; t.anisotropy = 8;
    return t;
  }
  function floorTex(Wc, Dc) {
    // ljust ekgolv: plankor 20 cm breda, 1 px = 1 cm
    return canvasTex(Math.round(Wc), Math.round(Dc), function (g, w, h) {
      var seed = 7; function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
      for (var x = 0; x < w; x += 20) {
        var y = -rnd() * 180;
        while (y < h) {
          var len = 140 + rnd() * 140, v = Math.round(rnd() * 8 - 4);
          g.fillStyle = 'rgb(' + (196 + v) + ',' + (168 + v) + ',' + (132 + v) + ')';
          g.fillRect(x, y, 20, len);
          g.fillStyle = 'rgba(120,90,60,.10)'; g.fillRect(x, y, 20, 1); g.fillRect(x, y, 1, len);
          y += len;
        }
      }
    });
  }

  // ---- byggklossar ----
  var T3;
  var matCache = {};
  function mat(hex, o) {
    o = o || {};
    var key = (hex || '#cccccc') + '|' + (o.r != null ? o.r : .85) + '|' + (o.m || 0) + '|' + (o.t || 1);
    if (!matCache[key]) matCache[key] = new T3.MeshStandardMaterial({ color: new T3.Color(hex || '#cccccc').convertSRGBToLinear(), roughness: o.r != null ? o.r : .85, metalness: o.m || 0, transparent: !!o.t, opacity: o.t || 1 });
    return matCache[key];
  }
  function mesh(g, m, x, y, z, parent) {
    var me = new T3.Mesh(g, m); me.position.set(x || 0, y || 0, z || 0);
    me.castShadow = true; me.receiveShadow = true; parent.add(me); return me;
  }
  // rundad lada: w x h x d med kantradie r, centrerad
  function rbox(w, h, d, r, m, x, y, z, parent) {
    r = Math.max(0.2, Math.min(r, w / 2 - .1, h / 2 - .1, d / 2 - .1));
    var s = new T3.Shape(), a = w / 2 - r, b = h / 2 - r;
    s.moveTo(-a, -b); s.lineTo(a, -b); s.lineTo(a, b); s.lineTo(-a, b); s.lineTo(-a, -b);
    var g = new T3.ExtrudeGeometry(s, { depth: Math.max(.1, d - 2 * r), bevelEnabled: true, bevelThickness: r, bevelSize: r, bevelSegments: 3, curveSegments: 4 });
    g.translate(0, 0, -(d - 2 * r) / 2);
    return mesh(g, m, x, y, z, parent);
  }
  function bx(w, h, d, m, x, y, z, parent) { return mesh(new T3.BoxGeometry(w, h, d), m, x, y, z, parent); }
  function cyl(rt, rb, h, m, x, y, z, parent, seg) { return mesh(new T3.CylinderGeometry(rt, rb, h, seg || 24), m, x, y, z, parent); }
  function sph(r, m, x, y, z, parent, sy) { var me = mesh(new T3.SphereGeometry(r, 24, 16), m, x, y, z, parent); if (sy) me.scale.y = sy; return me; }
  function legs4(w, d, h, r, m, g, inset) {
    inset = inset || 6;
    [[-1, -1], [1, -1], [-1, 1], [1, 1]].forEach(function (k) { cyl(r, r * .8, h, m, k[0] * (w / 2 - inset), h / 2, k[1] * (d / 2 - inset), g, 10); });
  }

  // ---- mobler: varje funktion bygger en grupp med fotavtryck centrerat, framsida mot +z ----
  function cols(p) {
    var c = p.col || [], main = c[0] || '#cfc8c0', mid = c[1] || main, top = c[2] || main, bot = c[3] || '#3a3530';
    return { main: main, mid: mid, top: top, bot: bot };
  }
  function buildSofa(p, g, single) {
    var c = cols(p), w = p.dw, d = p.dd || 92, h = p.dh || 80, st = p.st || 'box-legs';
    var fab = mat(c.main, { r: .95 }), legM = mat(c.bot, { r: .6, m: .2 });
    var legH = /legs/.test(st) ? 14 : /plinth/.test(st) ? 6 : /round|channel/.test(st) ? 6 : 3;
    var round = /round|channel|tub|club|shell/.test(st), rr = round ? 16 : 7;
    var armW = single ? Math.min(20, w * .18) : (round ? 24 : 18), seatTop = legH + (st === 'box-low' ? 34 : 44);
    var armH = Math.min(h, seatTop + (round ? 18 : 20)), backT = round ? 26 : 20;
    if (/plinth/.test(st)) bx(w - 6, legH, d - 6, mat(c.bot, { r: .7 }), 0, legH / 2, 0, g);
    else if (legH > 4) legs4(w, d, legH, 2.2, legM, g, 10);
    rbox(w, seatTop - legH - 12, d, rr * .6, fab, 0, legH + (seatTop - legH - 12) / 2, 0, g);
    var inner = w - 2 * armW, n = single ? 1 : Math.max(1, Math.round(inner / 75)), cw = inner / n;
    for (var i = 0; i < n; i++) rbox(cw - 1.5, 14, d - backT - 2, round ? 7 : 5, fab, -inner / 2 + cw * (i + .5), seatTop - 7, backT / 2, g);
    if (st === 'channel') {
      var nb = Math.max(3, Math.round(w / 32)), bw = w / nb;
      for (var j = 0; j < nb; j++) rbox(bw - 1, h - legH - 6, backT, bw / 2 - 1, fab, -w / 2 + bw * (j + .5), legH + 6 + (h - legH - 6) / 2, -d / 2 + backT / 2, g);
      rbox(armW + 4, armH - legH, d, 12, fab, -w / 2 + (armW + 4) / 2, legH + (armH - legH) / 2, 0, g);
      rbox(armW + 4, armH - legH, d, 12, fab, w / 2 - (armW + 4) / 2, legH + (armH - legH) / 2, 0, g);
    } else {
      rbox(w, h - legH, backT, rr * .7, fab, 0, legH + (h - legH) / 2, -d / 2 + backT / 2, g);
      rbox(armW, armH - legH, d, rr * .7, fab, -w / 2 + armW / 2, legH + (armH - legH) / 2, 0, g);
      rbox(armW, armH - legH, d, rr * .7, fab, w / 2 - armW / 2, legH + (armH - legH) / 2, 0, g);
      if (!single && !round) for (var k = 0; k < n; k++) rbox(cw - 8, Math.min(42, h - seatTop + 4), 16, 8, fab, -inner / 2 + cw * (k + .5), seatTop + Math.min(42, h - seatTop + 4) / 2, -d / 2 + backT + 7, g);
    }
    if (st === 'chaise') { var cd = 72; rbox(85, seatTop - legH, cd, 6, fab, -w / 2 + 42.5, legH + (seatTop - legH) / 2, d / 2 + cd / 2 - 2, g); }
    if (st === 'corner') { var wd = Math.min(170, d * 1.8); rbox(95, seatTop - legH, wd, 6, fab, w / 2 - 47.5, legH + (seatTop - legH) / 2, d / 2 + wd / 2 - 2, g); }
  }
  function buildArmchair(p, g) {
    var c = cols(p), st = p.st || 'tub', w = p.dw, d = p.dd || 80, h = p.dh || 80;
    var fab = mat(c.main, { r: .95 }), metal = mat('#1d1d1f', { r: .4, m: .6 }), wood = mat(c.bot, { r: .6 });
    if (/frame-metal|frame-wood/.test(st)) {
      var fm = st === 'frame-metal' ? metal : wood, t = st === 'frame-metal' ? 2 : 4;
      [-1, 1].forEach(function (s) {
        bx(t, 60, t, fm, s * (w / 2 - t), 30, d / 2 - 6, g); bx(t, h, t, fm, s * (w / 2 - t), h / 2, -d / 2 + 6, g);
        bx(t, t, d - 8, fm, s * (w / 2 - t), 60, 0, g); bx(t, t, d - 8, fm, s * (w / 2 - t), 18, 0, g);
      });
      rbox(w - 10, 14, d - 14, 6, fab, 0, 36, 4, g);
      var back = rbox(w - 10, h - 34, 14, 6, fab, 0, 36 + (h - 34) / 2, -d / 2 + 12, g); back.rotation.x = -.18;
      return;
    }
    if (/sling-wood/.test(st)) {
      [-1, 1].forEach(function (s) { var a = bx(4, 6, d, wood, s * (w / 2 - 4), 40, 0, g); a.rotation.x = .25; bx(4, 40, 4, wood, s * (w / 2 - 4), 20, d / 2 - 8, g); bx(4, 60, 4, wood, s * (w / 2 - 4), 30, -d / 2 + 8, g); });
      var sl = bx(w - 10, 3, d - 6, fab, 0, 34, 0, g); sl.rotation.x = .35;
      return;
    }
    var legH = /legs|shell|wing|lounge|club/.test(st) ? 12 : 3;
    if (legH > 4) legs4(w, d, legH, 2, wood, g, 10);
    rbox(w, 30, d, 12, fab, 0, legH + 15, 0, g);
    rbox(w * .86, 12, d * .7, 6, fab, 0, legH + 34, d * .1, g);
    var bk = rbox(w, h - legH, 22, 11, fab, 0, legH + (h - legH) / 2, -d / 2 + 11, g);
    if (/wing/.test(st)) { rbox(16, h - legH - 8, d * .6, 8, fab, -w / 2 + 8, legH + (h - legH) / 2, -d * .15, g); rbox(16, h - legH - 8, d * .6, 8, fab, w / 2 - 8, legH + (h - legH) / 2, -d * .15, g); }
    else { rbox(18, (h - legH) * .62, d * .9, 9, fab, -w / 2 + 9, legH + (h - legH) * .31, 0, g); rbox(18, (h - legH) * .62, d * .9, 9, fab, w / 2 - 9, legH + (h - legH) * .31, 0, g); }
    if (/ottoman/.test(st)) { var o = new T3.Group(); legs4(w * .7, 45, 12, 1.8, wood, o, 6); rbox(w * .7, 26, 45, 10, fab, 0, 25, 0, o); o.position.set(0, 0, d / 2 + 38); g.add(o); }
  }
  function buildChair(p, g) {
    var c = cols(p), st = p.st || 'chair-wood', w = p.dw, d = p.dd || 56, h = p.dh || 82;
    var fab = mat(c.mid, { r: .95 }), wood = mat(c.bot, { r: .55 }), seatY = 46;
    if (/swivel/.test(st)) {
      cyl(3, 3, seatY - 10, mat(/wood/.test(st) ? c.bot : '#1d1d1f', { r: .4, m: .5 }), 0, (seatY - 10) / 2, 0, g, 12);
      for (var i = 0; i < 4; i++) { var leg = bx(3, 2.5, w * .5, mat(/wood/.test(st) ? c.bot : '#1d1d1f', { r: .4, m: .5 }), 0, 1.5, 0, g); leg.rotation.y = i * Math.PI / 2 + Math.PI / 4; leg.geometry.translate(0, 0, w * .25); }
      rbox(w, 14, d, 7, fab, 0, seatY, 0, g);
      rbox(w, h - seatY, 16, 8, fab, 0, seatY + (h - seatY) / 2, -d / 2 + 8, g);
      rbox(10, 22, d * .7, 5, fab, -w / 2 + 5, seatY + 12, -2, g); rbox(10, 22, d * .7, 5, fab, w / 2 - 5, seatY + 12, -2, g);
      return;
    }
    legs4(w, d, seatY - 4, 1.8, wood, g, 4);
    rbox(w * .95, 7, d * .9, 3, fab, 0, seatY, 0, g);
    if (/spindle/.test(st)) {
      for (var s = 0; s < 7; s++) cyl(.8, .8, h - seatY - 6, wood, -w * .35 + s * w * .7 / 6, seatY + (h - seatY) / 2, -d / 2 + 5, g, 6);
      bx(w * .9, 4, 4, wood, 0, h - 3, -d / 2 + 5, g);
    } else {
      bx(2.5, h - seatY, 2.5, wood, -w / 2 + 4, seatY + (h - seatY) / 2 - 2, -d / 2 + 4, g);
      bx(2.5, h - seatY, 2.5, wood, w / 2 - 4, seatY + (h - seatY) / 2 - 2, -d / 2 + 4, g);
      var bk = rbox(w * .9, 20, 4, 2, /arms/.test(st) ? wood : fab, 0, h - 12, -d / 2 + 5, g); bk.rotation.x = -.12;
    }
    if (/arms/.test(st)) { bx(3, 3, d * .8, wood, -w / 2 + 3, seatY + 20, 0, g); bx(3, 3, d * .8, wood, w / 2 - 3, seatY + 20, 0, g); bx(2.5, 20, 2.5, wood, -w / 2 + 3, seatY + 10, d * .35, g); bx(2.5, 20, 2.5, wood, w / 2 - 3, seatY + 10, d * .35, g); }
  }
  function buildTable(p, g) {
    var c = cols(p), st = p.st || 'rect-legs', w = p.dw, h = p.dh || 75, isRound = p.round || /^round/.test(st), d = isRound ? w : (p.dd || w * .6);
    var topM = /glass/.test(st) ? mat('#cfe0e4', { r: .05, m: .1, t: .35 }) : /marble/.test(st) ? mat('#eeeeec', { r: .3 }) : mat(c.top, { r: .55 });
    var legM = /metal/.test(st) ? mat('#1d1d1f', { r: .4, m: .6 }) : mat(c.bot, { r: .6 }), th = /slab|drum/.test(st) ? 4 : 3.5;
    if (isRound || /oval/.test(st)) {
      var top = cyl(w / 2, w / 2, th, topM, 0, h - th / 2, 0, g, 48); if (/oval/.test(st)) top.scale.z = d / w;
      if (/pedestal|oval/.test(st)) { cyl(w * .12, w * .2, h - th, legM, 0, (h - th) / 2, 0, g, 32); }
      else if (/cone/.test(st)) cyl(w * .14, w * .32, h - th, mat(c.bot, { r: .6 }), 0, (h - th) / 2, 0, g, 32);
      else if (/drum/.test(st)) cyl(w * .42, w * .42, h - th, /glass/.test(st) ? mat('#1f1d1c', { r: .6 }) : mat(c.mid, { r: .7 }), 0, (h - th) / 2, 0, g, 40);
      else if (/slab/.test(st)) { bx(w * .7, h - th, 4, mat(c.mid, { r: .7 }), 0, (h - th) / 2, 0, g); var s2 = bx(w * .7, h - th, 4, mat(c.mid, { r: .7 }), 0, (h - th) / 2, 0, g); s2.rotation.y = Math.PI / 2; }
      else [0, 1, 2, 3].forEach(function (i) { var a = i * Math.PI / 2 + Math.PI / 4; cyl(1.5, 1.5, h - th, legM, Math.cos(a) * w * .36, (h - th) / 2, Math.sin(a) * w * .36, g, 8); });
      return;
    }
    bx(w, th, d, topM, 0, h - th / 2, 0, g);
    if (/metal-(glass|marble)/.test(st)) {
      [-1, 1].forEach(function (s) { bx(2, h - th, 2, legM, s * (w / 2 - 2), (h - th) / 2, d / 2 - 2, g); bx(2, h - th, 2, legM, s * (w / 2 - 2), (h - th) / 2, -d / 2 + 2, g); bx(2, 2, d, legM, s * (w / 2 - 2), 1, 0, g); });
      return;
    }
    if (/xlegs/.test(st)) {
      [-1, 1].forEach(function (s) {
        var len = Math.sqrt((h - th) * (h - th) + d * .8 * d * .8), ang = Math.atan2(d * .8, h - th);
        var a = bx(5, len, 5, legM, s * (w / 2 - 25), (h - th) / 2, 0, g); a.rotation.x = ang;
        var b = bx(5, len, 5, legM, s * (w / 2 - 25), (h - th) / 2, 0, g); b.rotation.x = -ang;
      });
      return;
    }
    if (/slab/.test(st)) { bx(8, h - th, d * .8, legM, -w / 2 + 25, (h - th) / 2, 0, g); bx(8, h - th, d * .8, legM, w / 2 - 25, (h - th) / 2, 0, g); return; }
    if (/pillars/.test(st)) { cyl(13, 13, h - th, mat(c.bot, { r: .7 }), -w / 2 + 35, (h - th) / 2, 0, g, 32); cyl(13, 13, h - th, mat(c.bot, { r: .7 }), w / 2 - 35, (h - th) / 2, 0, g, 32); return; }
    if (/pedestal/.test(st)) { cyl(w * .1, w * .14, h - th, legM, 0, (h - th) / 2, 0, g, 32); return; }
    legs4(w, d, h - th, 2.5, legM, g, 5);
    if (/shelf/.test(st)) bx(w - 8, 2, d - 8, topM, 0, 12, 0, g);
  }
  function buildStorage(p, g) {
    var c = cols(p), st = p.st || 'cabinet-wood', w = p.dw, h = p.dh || 80, d = p.dd || 40;
    var body = mat(c.main, { r: .6 }), legH = h > 120 ? 8 : 10, bh = h - legH;
    if (/shelf-open/.test(st)) {
      [-1, 1].forEach(function (s) { bx(3, h, d, body, s * (w / 2 - 1.5), h / 2, 0, g); });
      for (var i = 0; i < 4; i++) bx(w, 2, d, body, 0, 2 + i * (h - 4) / 3, 0, g);
      return;
    }
    legs4(w, d, legH, 1.6, mat(c.bot, { r: .5, m: .3 }), g, 4);
    bx(w, bh, d, body, 0, legH + bh / 2, 0, g);
    var n = Math.max(1, Math.round(w / 45)), dw = w / n;
    for (var k = 0; k < n; k++) {
      var x = -w / 2 + dw * (k + .5);
      if (/glass/.test(st)) {
        bx(dw - 2, bh - 4, 1, mat(c.mid, { r: .5 }), x, legH + bh / 2, d / 2 + .3, g);
        bx(dw - 8, bh - 12, .6, mat('#d9e4e6', { r: .05, t: .45 }), x, legH + bh / 2, d / 2 + 1, g);
      } else if (/ribbed/.test(st)) {
        for (var r = 0; r < dw / 4; r++) bx(2, bh - 4, 1.2, mat(c.mid, { r: .7 }), x - dw / 2 + 2 + r * 4, legH + bh / 2, d / 2 + .6, g);
      } else bx(dw - 1.5, bh - 3, 1, mat(c.mid, { r: .6 }), x, legH + bh / 2, d / 2 + .5, g);
    }
  }
  function buildWallShelf(p, g) {
    var c = cols(p), w = p.dw, h = p.dh || 62, d = p.dd || 18, m = mat(c.main, { r: .6 });
    [-1, 1].forEach(function (s) { bx(2, h, 2, m, s * (w / 2 - 1), h / 2, d / 2 - 1, g); bx(2, h, 2, m, s * (w / 2 - 1), h / 2, -d / 2 + 1, g); });
    var n = h > 90 ? 3 : 2;
    for (var i = 0; i < n; i++) bx(w, 1.5, d, m, 0, 2 + i * (h - 4) / (n - 1), 0, g);
  }
  function buildLamp(p, g, H) {
    var c = cols(p), st = p.st || 'floor-shade', shadeM = mat(c.top, { r: .9 }), metal = mat('#2a2826', { r: .4, m: .6 });
    if (/^floor/.test(st)) {
      var hh = p.dh || 155;
      if (st === 'floor-tripod') { [0, 1, 2].forEach(function (i) { var a = i * 2.09, l = cyl(.9, .9, hh - 30, mat(c.mid, { r: .5 }), Math.cos(a) * 12, (hh - 30) / 2, Math.sin(a) * 12, g, 6); l.rotation.z = Math.cos(a) * .12; l.rotation.x = -Math.sin(a) * .12; }); }
      else { cyl(14, 14, 2, metal, 0, 1, 0, g); cyl(1, 1, hh - 25, metal, 0, (hh - 25) / 2, 0, g, 8); }
      if (st === 'floor-dome') { var dm = sph(16, mat(c.top, { r: .5 }), 0, hh - 14, 0, g, .7); dm.geometry = new T3.SphereGeometry(16, 24, 12, 0, Math.PI * 2, 0, Math.PI / 2); }
      else if (st === 'floor-arm') { var arm = bx(1.5, 1.5, 55, metal, 0, hh - 18, 22, g); arm.rotation.x = -.15; cyl(6, 10, 14, shadeM, 0, hh - 24, 48, g); }
      else cyl(15, 19, 28, shadeM, 0, hh - 14, 0, g, 32);
      return;
    }
    if (st === 'table-dome') { cyl(6, 8, 30, mat(c.bot, { r: .5 }), 0, 15, 0, g); var td = sph(17, mat(c.main, { r: .5 }), 0, 34, 0, g); td.geometry = new T3.SphereGeometry(17, 24, 12, 0, Math.PI * 2, 0, Math.PI / 2); return; }
    // taklampa: hanger fran taket, underkant ca 150 cm
    var y = 150, top;
    if (st === 'pend-globe') { sph(15, mat('#dfe8ea', { r: .05, t: .4 }), 0, y + 15, 0, g); sph(5, mat('#ffffff', { r: .3 }), 0, y + 15, 0, g); top = y + 30; }
    else if (st === 'pend-ball') { sph(22, mat(c.main, { r: 1 }), 0, y + 22, 0, g, 1.05); top = y + 45; }
    else if (st === 'pend-feather') { sph(26, mat(c.main, { r: 1 }), 0, y + 14, 0, g, .55); top = y + 28; }
    else if (st === 'pend-ring') { var tr = mesh(new T3.TorusGeometry(40, 1.2, 8, 48), metal, 0, y + 10, 0, g); tr.rotation.x = Math.PI / 2; top = y + 10; }
    else if (st === 'pend-track') { bx(120, 3, 3, metal, 0, y + 30, 0, g); [-45, 0, 45].forEach(function (x) { cyl(1, 6, 8, metal, x, y + 22, 0, g); cyl(.4, .4, 10, metal, x, y + 27, 0, g); }); top = y + 30; }
    else { cyl(3, 34, 14, mat(c.main, { r: 1 }), 0, y + 7, 0, g, 40); top = y + 14; }
    cyl(.4, .4, H - top, mat('#4a443e', { r: .5 }), 0, top + (H - top) / 2, 0, g, 6);
  }
  function buildPart(code, H) {
    var p = D.parts[code], g = new T3.Group();
    if (p.c === 'soffa') buildSofa(p, g);
    else if (p.c === 'fatolj') { if (/box|club/.test(p.st) && !/tub/.test(p.st)) buildSofa(p, g, true); else buildArmchair(p, g); }
    else if (p.c === 'matstol') buildChair(p, g);
    else if (p.c === 'matbord' || p.c === 'soffbord' || p.c === 'sidobord') buildTable(p, g);
    else if (p.c === 'forvaring') buildStorage(p, g);
    else if (p.c === 'vagghylla') buildWallShelf(p, g);
    else buildLamp(p, g, H);
    return g;
  }

  // ---- rummet ----
  function init3D() {
    T3 = THREE;
    var T = THREE, w = roomEl.clientWidth || 600, h = Math.round(w * 9 / 16);
    var renderer = new T.WebGLRenderer({ antialias: true });
    renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
    renderer.setSize(w, h);
    renderer.outputEncoding = T.sRGBEncoding;
    renderer.toneMapping = T.ACESFilmicToneMapping; renderer.toneMappingExposure = .95;
    renderer.shadowMap.enabled = true; renderer.shadowMap.type = T.PCFSoftShadowMap;
    roomEl.classList.remove('ms-room-grid');
    roomEl.innerHTML = '';
    roomEl.appendChild(renderer.domElement);
    roomEl.style.aspectRatio = 'auto';
    var hint = document.createElement('span'); hint.className = 'ms-3d-hint'; hint.textContent = '↔ Dra för att vrida rummet';
    roomEl.appendChild(hint);
    var scene = new T.Scene(); scene.background = new T.Color(0xf3eee7);
    var camera = new T.PerspectiveCamera(38, w / h, 10, 6000);
    scene.add(new T.HemisphereLight(0xfff6ec, 0xb89f80, .55));
    var sun = new T.DirectionalLight(0xfff0dc, 1.55);
    sun.castShadow = true; sun.shadow.mapSize.set(2048, 2048); sun.shadow.bias = -0.0005; sun.shadow.radius = 4;
    scene.add(sun); scene.add(sun.target);
    R3 = { renderer: renderer, scene: scene, camera: camera, sun: sun, group: new T.Group(), yaw: 0, pitch: .42, W: 500, D: 400, H: 260 };
    scene.add(R3.group);
    var el = renderer.domElement, sx = null, sy = 0, y0 = 0, p0 = 0;
    el.style.touchAction = 'pan-y'; el.style.cursor = 'grab';
    el.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; y0 = R3.yaw; p0 = R3.pitch; el.style.cursor = 'grabbing'; hint.style.opacity = 0; });
    window.addEventListener('pointermove', function (e) {
      if (sx === null) return;
      R3.yaw = Math.max(-1.1, Math.min(1.1, y0 - (e.clientX - sx) / 260));
      if (e.pointerType === 'mouse') R3.pitch = Math.max(.2, Math.min(.75, p0 + (e.clientY - sy) / 400));
      draw3D();
    });
    window.addEventListener('pointerup', function () { sx = null; el.style.cursor = 'grab'; });
    if (window.ResizeObserver) new ResizeObserver(function () {
      var nw = roomEl.clientWidth; if (!nw || !R3) return;
      var nh = Math.round(nw * 9 / 16); R3.renderer.setSize(nw, nh); R3.camera.aspect = nw / nh; R3.camera.updateProjectionMatrix(); draw3D();
    }).observe(roomEl);
  }
  function clearGroup(g) {
    g.traverse(function (o) { if (o.geometry) o.geometry.dispose(); if (o.material && o.material.map) o.material.map.dispose(); });
    while (g.children.length) g.remove(g.children[0]);
  }
  // planlosning i cm: x = sida, z = djup (bakvagg vid z = -D)
  function layout() {
    var items = [], r = pkg.r, Dp = 420, by = {};
    slots.forEach(function (s) { var c = D.parts[s.c].c; (by[c] = by[c] || []).push(s); });
    function W_(s) { return D.parts[s.c].dw; }
    function Dd(s) { var p = D.parts[s.c]; return p.round ? p.dw : (p.dd || 60); }
    function zoneV(ox) {
      var so = by.soffa && by.soffa[0], sw = so ? W_(so) : 200, sd = so ? Dd(so) : 90, ext = sw / 2 + 60, left = -sw / 2 - 15;
      if (so) items.push({ c: so.c, x: ox, z: -Dp + sd / 2 + 8 });
      (by.sidobord || []).forEach(function (s) { var w = W_(s); items.push({ c: s.c, x: ox + left - w / 2, z: -Dp + Dd(s) / 2 + 15 }); left -= w + 15; });
      var tz = -Dp + sd + 75;
      (by.soffbord || []).forEach(function (s) { items.push({ c: s.c, x: ox, z: tz + Dd(s) / 2 }); tz += 0; });
      (by.fatolj || []).forEach(function (s, i) {
        var w = W_(s), side = i ? -1 : 1;
        items.push({ c: s.c, x: ox + side * (sw / 2 + w / 2 + 5), z: -Dp + sd + 135, ry: -side * .7 });
        ext = Math.max(ext, sw / 2 + w + 10);
      });
      var right = sw / 2 + 15;
      if (r === 'V') (by.golvlampa || []).forEach(function (s) { items.push({ c: s.c, x: ox + right + 20, z: -Dp + 30 }); right += 50; });
      if (r === 'V') (by.forvaring || []).forEach(function (s) { var w = W_(s); items.push({ c: s.c, x: ox + right + w / 2 + 10, z: -Dp + Dd(s) / 2 + 2, fv: 1 }); right += w + 25; });
      if (r === 'V') (by.vagghylla || []).forEach(function (s) { items.push({ c: s.c, x: ox - sw / 4, z: -Dp + Dd(s) / 2 + 1, y: 120 }); });
      return { ext: Math.max(ext, right + 20, -left + 20) };
    }
    function zoneM(ox) {
      var tb = by.matbord && by.matbord[0], tw = tb ? W_(tb) : 160, td = tb ? Dd(tb) : 90, tz = -Dp + 85 + td / 2 + 70;
      if (tb) items.push({ c: tb.c, x: ox, z: tz });
      var ch = by.matstol && by.matstol[0], ext = tw / 2 + 70;
      if (ch) {
        var n = chairCount(ch), cd = Dd(ch), perSide = Math.max(1, Math.ceil(n / 2));
        var ends = n >= 6 && tw >= 200 ? 0 : 0, along = n - ends;
        var back = Math.ceil(along / 2), front = along - back;
        var stepB = tw / Math.max(back, 1), stepF = tw / Math.max(front, 1);
        for (var i = 0; i < back; i++) items.push({ c: ch.c, x: ox - tw / 2 + stepB * (i + .5), z: tz - td / 2 - cd / 2 + 12, ry: 0 });
        for (var j = 0; j < front; j++) items.push({ c: ch.c, x: ox - tw / 2 + stepF * (j + .5), z: tz + td / 2 + cd / 2 - 12, ry: Math.PI });
        ext = tw / 2 + 40;
      }
      (by.forvaring || []).forEach(function (s, i) { var w = W_(s); items.push({ c: s.c, x: ox + (i ? -1 : 1) * Math.max(0, tw / 2 - w / 3), z: -Dp + Dd(s) / 2 + 2, fv: 1 }); ext = Math.max(ext, tw / 2 + w / 2); });
      if (r !== 'V') (by.golvlampa || []).forEach(function (s) { items.push({ c: s.c, x: ox - ext - 10, z: -Dp + 30 }); ext += 40; });
      if (r !== 'V') (by.vagghylla || []).forEach(function (s) { items.push({ c: s.c, x: ox - tw / 3, z: -Dp + Dd(s) / 2 + 1, y: 130 }); });
      return { ext: ext + 20 };
    }
    var W;
    if (r === 'V') { var v = zoneV(0); W = Math.max(480, v.ext * 2 + 40); }
    else if (r === 'M') { var m = zoneM(0); W = Math.max(440, m.ext * 2 + 40); }
    else {
      var start = items.length, vz = zoneV(0), vItems = items.splice(start);
      var mz = zoneM(0), mItems = items.splice(start);
      W = Math.max(700, vz.ext * 2 + mz.ext * 2);
      var oxV = -W / 2 + vz.ext + 20, oxM = W / 2 - mz.ext - 20;
      vItems.forEach(function (it) { it.x += oxV; items.push(it); });
      mItems.forEach(function (it) { it.x += oxM; items.push(it); });
    }
    var lampsAt = [];
    items.forEach(function (it) { var c = D.parts[it.c].c; if (c === 'matbord' || c === 'soffbord') lampsAt.push({ x: it.x, z: it.z, t: c }); });
    lampsAt.sort(function (a, b) { return (a.t === 'matbord' ? 0 : 1) - (b.t === 'matbord' ? 0 : 1); });
    (by.taklampa || []).forEach(function (s, i) { var at = lampsAt[i] || lampsAt[0] || { x: 0, z: -Dp / 2 }; items.push({ c: s.c, x: at.x, z: at.z }); });
    (by.bordslampa || []).forEach(function (s) {
      var fv = items.filter(function (it) { return it.fv; })[0];
      if (fv) items.push({ c: s.c, x: fv.x - D.parts[fv.c].dw / 4, z: fv.z, y: D.parts[fv.c].dh });
      else items.push({ c: s.c, x: 0, z: -Dp + 40 });
    });
    return { items: items, W: W, D: Dp };
  }
  function build3D() {
    var T = THREE, L = layout(), W = L.W, Dp = L.D, H = R3.H;
    R3.W = W; R3.D = Dp;
    clearGroup(R3.group);
    var ft = floorTex(W, Dp);
    var floor = new T.Mesh(new T.PlaneGeometry(W, Dp), new T.MeshStandardMaterial({ map: ft, roughness: .8 }));
    floor.rotation.x = -Math.PI / 2; floor.position.set(0, 0, -Dp / 2); floor.receiveShadow = true; R3.group.add(floor);
    var wallM = new T.MeshStandardMaterial({ color: new T.Color('#e8dfd2').convertSRGBToLinear(), roughness: 1 });
    var back = new T.Mesh(new T.PlaneGeometry(W, H), wallM); back.position.set(0, H / 2, -Dp); back.receiveShadow = true; R3.group.add(back);
    var lw = new T.Mesh(new T.PlaneGeometry(Dp, H), wallM); lw.rotation.y = Math.PI / 2; lw.position.set(-W / 2, H / 2, -Dp / 2); lw.receiveShadow = true; R3.group.add(lw);
    var rw = new T.Mesh(new T.PlaneGeometry(Dp, H), wallM); rw.rotation.y = -Math.PI / 2; rw.position.set(W / 2, H / 2, -Dp / 2); rw.receiveShadow = true; R3.group.add(rw);
    var base = new T.MeshStandardMaterial({ color: 0xf7f3ee, roughness: .8 });
    [[W, 0, -Dp + .6, 0], [Dp, -W / 2 + .6, -Dp / 2, Math.PI / 2], [Dp, W / 2 - .6, -Dp / 2, -Math.PI / 2]].forEach(function (b) {
      var m = new T.Mesh(new T.BoxGeometry(b[0], 8, 1.2), base); m.position.set(b[1], 4, b[2]); m.rotation.y = b[3]; R3.group.add(m);
    });
    L.items.forEach(function (it) {
      var g = buildPart(it.c, H);
      g.position.set(it.x, it.y || 0, it.z);
      if (it.ry) g.rotation.y = it.ry;
      R3.group.add(g);
    });
    var s = R3.sun; s.position.set(-W * .45, 380, Dp * .35); s.target.position.set(0, 0, -Dp / 2);
    var sc = s.shadow.camera; sc.left = -W; sc.right = W; sc.top = Dp; sc.bottom = -Dp; sc.near = 50; sc.far = 1500; sc.updateProjectionMatrix();
    draw3D();
  }
  function draw3D() {
    if (!R3) return;
    var c = R3.camera, W = R3.W, Dp = R3.D;
    var tz = -Dp * .55, dist = W * (pkg && pkg.r === 'K' ? .66 : pkg && pkg.r === 'M' ? 1.0 : .82) + 110;
    var horiz = Math.cos(R3.pitch) * dist;
    c.position.set(Math.sin(R3.yaw) * horiz, 70 + Math.sin(R3.pitch) * dist, tz + Math.cos(R3.yaw) * horiz);
    c.lookAt(0, 65, tz);
    R3.renderer.render(R3.scene, c);
  }
  function renderRoom() {
    return; // gamla Ditt rum-vyn är borttagen – bytena sker i 3D-vyn (ms-rum3d.js)
    if (!pkg) { roomEl.innerHTML = ''; return; }
    if (R3 === false) return renderGrid();
    if (!window.THREE) { if (!roomEl.firstChild) roomEl.innerHTML = '<span class="ms-3d-load">Bygger rummet…</span>'; return loadThree(renderRoom); }
    try { if (!R3) init3D(); build3D(); } catch (e) { console.error('Ditt rum 3D', e); R3 = false; renderGrid(); }
  }
  window.addEventListener('resize', function () { clearTimeout(window.__msr); window.__msr = setTimeout(function () { placeRoom(); }, 150); });

  // ---------- byt ----------
  function candidates(i) {
    var s = slots[i], cur = D.parts[s.c], orig = D.parts[s.oc], codes = [];
    Object.keys(D.parts).forEach(function (c) {
      var p = D.parts[c];
      if (p.c !== cur.c) return;
      if (slots.some(function (o, k) { return k !== i && o.c === c; })) return; // finns redan i paketet
      codes.push(c);
    });
    return Promise.all(codes.map(function (c) { return prod(c).then(function (p) { info[c] = p; return c; }, function () { return null; }); }))
      .then(function () {
        var curP = info[s.c], curV = curP && variantOf(curP, s.v), curPrice = curV ? curV.price * s.q : 0, list = [];
        codes.forEach(function (c) {
          var p = info[c]; if (!p) return;
          p.variants.forEach(function (v) {
            if (!v.available) return;
            if (c === s.c && v.id === s.v) return;
            var q = s.q;
            if (cur.c === 'matstol') q = Math.ceil(chairCount(s) / (D.parts[c].pk || 1));
            list.push({ c: c, v: v, q: q, p: p, diff: v.price * q - curPrice });
          });
        });
        list.sort(function (a, b) { return Math.abs(a.diff) - Math.abs(b.diff); });
        return list;
      });
  }
  function openSwap(i) {
    var s = slots[i], cat = D.parts[s.c].c;
    openPop('<h3>Byt ' + CAT[cat] + '</h3><p class="ms-load">Hämtar alternativ…</p>');
    candidates(i).then(function (list) {
      var h = '<h3>Byt ' + CAT[cat] + '</h3>';
      if (s.c !== s.oc || s.v !== s.ov) h += '<button type="button" class="ms-alt ms-orig" data-i="' + i + '" data-c="' + s.oc + '" data-v="' + s.ov + '" data-q="' + s.oq + '">↺ Tillbaka till originalet</button>';
      if (!list.length) h += '<p>Det finns inga andra ' + CAT[cat] + ' i lager just nu.</p>';
      h += list.map(function (a) {
        var d = a.diff === 0 ? 'Samma pris' : (a.diff > 0 ? '+' : '−') + kr(Math.abs(a.diff));
        return '<button type="button" class="ms-alt" data-i="' + i + '" data-c="' + a.c + '" data-v="' + a.v.id + '" data-q="' + a.q + '">' +
          '<img src="' + img(a.p.featured_image, 200) + '" alt="" loading="lazy"><span><b>' + esc(a.p.title) + (a.p.variants.length > 1 ? ' – ' + esc(a.v.title) : '') + '</b>' +
          (cat === 'matstol' ? '<small>' + a.q + ' st' + ((D.parts[a.c].pk || 1) > 1 ? ' × 2-pack' : '') + '</small>' : '') +
          '<em class="' + (a.diff > 0 ? 'up' : (a.diff < 0 ? 'dn' : '')) + '">' + d + '</em></span></button>';
      }).join('');
      popBody.innerHTML = h;
    });
  }
  function doSwap(i, c, v, q) {
    var s = slots[i], cat = D.parts[s.c].c;
    s.c = c; s.v = v; s.q = q;
    closePop(); render();
    if (cat === 'matbord') tableChanged();
  }
  function tableChanged() {
    var ch = slotOf('matstol'), tb = slotOf('matbord');
    if (!ch || !tb) return;
    var need = chairsFor(D.parts[tb.c].L), have = chairCount(ch), pk = D.parts[ch.c].pk || 1, min = origChairs();
    if (need > have) {
      openPop('<h3>Det här bordet är större</h3><p>Vi rekommenderar ' + need + ' stolar till det här bordet (du har ' + have + ').</p>' +
        '<div class="ms-btns"><button type="button" class="btn ms-addch" data-n="' + (need - have) + '">Lägg till ' + (need - have) + ' stolar</button>' +
        '<button type="button" class="ms-later" data-close>Gör det senare</button></div>');
    } else if (need < have && have > min) {
      var rem = have - Math.max(need, min);
      openPop('<h3>Det här bordet är mindre</h3><p>Det här bordet passar ' + need + ' stolar. Vill du ta bort ' + rem + '?</p>' +
        '<div class="ms-btns"><button type="button" class="btn ms-remch" data-n="' + rem + '">Ta bort ' + rem + '</button>' +
        '<button type="button" class="ms-later" data-close>Behåll ' + have + '</button></div>');
    }
  }
  function addChairs(n) { var ch = slotOf('matstol'); if (!ch) return; ch.q += Math.ceil(n / (D.parts[ch.c].pk || 1)); closePop(); render(); }
  function remChairs(n) { var ch = slotOf('matstol'); if (!ch) return; ch.q = Math.max(Math.ceil(origChairs() / (D.parts[ch.c].pk || 1)), ch.q - Math.floor(n / (D.parts[ch.c].pk || 1))); closePop(); render(); }

  function openInfo(i) {
    var p = info[slots[i].c]; if (!p) return;
    var g = (p.images || []).map(function (u, k) { return '<img class="' + (k ? '' : 'on') + '" src="' + img(u, 900) + '" alt="">'; }).join('');
    openPop((g ? '<div class="ms-gal"><div class="ms-gmain">' + g + '</div>' + (p.images.length > 1 ? '<button type="button" class="ms-gp" aria-label="Föregående">&#8249;</button><button type="button" class="ms-gn" aria-label="Nästa">&#8250;</button>' : '') + '</div>' : '') +
      '<h3>' + esc(p.title) + '</h3><div class="ms-desc">' + (p.description || '') + '</div><a class="btn" href="' + (location.pathname.indexOf('/sv/') === 0 ? '/sv' : '') + '/products/' + p.handle + '" target="_blank">Visa produktsidan</a>');
  }
  pop.addEventListener('click', function (e) {
    var a = e.target.closest('.ms-alt'); if (a) { doSwap(+a.dataset.i, a.dataset.c, +a.dataset.v, +a.dataset.q); return; }
    var ad = e.target.closest('.ms-addch'); if (ad) { addChairs(+ad.dataset.n); return; }
    var rm = e.target.closest('.ms-remch'); if (rm) { remChairs(+rm.dataset.n); return; }
    var nav = e.target.closest('.ms-gp, .ms-gn');
    if (nav) {
      var ims = popBody.querySelectorAll('.ms-gmain img'), k = 0;
      ims.forEach(function (im, x) { if (im.classList.contains('on')) k = x; });
      k = (k + (nav.classList.contains('ms-gn') ? 1 : -1) + ims.length) % ims.length;
      ims.forEach(function (im, x) { im.classList.toggle('on', x === k); });
    }
  });
  listEl.addEventListener('click', function (e) {
    var sw = e.target.closest('.ms-swap'); if (sw) { openSwap(+sw.dataset.i); return; }
    var inf = e.target.closest('.ms-info'); if (inf) { openInfo(+inf.dataset.i); return; }
    var ad = e.target.closest('.ms-addch'); if (ad) { addChairs(+ad.dataset.n); return; }
    if (e.target.closest('.ms-reset-btn')) load(curVid);
  });
  noteEl.querySelector('.ms-reset').addEventListener('click', function () { load(curVid); });

  // ---------- lagg i varukorgen ----------
  var busy = false;
  function addToCart(e) {
    if (e && e.preventDefault) { e.preventDefault(); e.stopImmediatePropagation(); }
    if (busy || !pkg) return;
    if (!slots.length) { alert('Lägg till minst en möbel först.'); return; }
    var tt = total(); if (tt !== null && tt < 1500000) { alert('Minsta ordervärde är 15 000 kr. Ändra möblerna och försök igen.'); return; }
    if (!allAvailable()) { alert('En del i paketet är slut i lager. Byt den till ett alternativ först.'); return; }
    busy = true; if (btn) btn.classList.add('ms-busy');
    var id = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var name = pkg.n + ' – ' + pkg.v + (modified() ? ' (anpassat)' : '');
    // montering: varje del som kraver montering raknas (stolar = en plats, skap = 2)
    var mont = slots.reduce(function (n, s) { return n + (D.parts[s.c].m || 0); }, 0);
    var items = slots.map(function (s, i) {
      var props = { 'Paket': name, '_pkg': id, '_n': String(slots.length), '_slot': String(i), '_url': location.pathname.split('?')[0] + '?variant=' + curVid + '&ms_edit=' + id, '_mont': i === 0 ? String(mont) : '0',
        '_c': s.c, '_oc': s.oc, '_ov': String(s.ov), '_oq': String(s.oq), '_add': s.add ? '1' : '0' };
      return { id: s.v, quantity: s.q, properties: props };
    });
    // Byt delar fran varukorgen: det gamla paketet tas bort nar det nya laggs i
    var clearOld = editId ? fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var u = {}; cart.items.forEach(function (it) { if (it.properties && it.properties._pkg === editId) u[it.key] = 0; });
      return Object.keys(u).length ? fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: u }) }) : null;
    }) : Promise.resolve();
    clearOld.then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items.reverse() }) }); }) // varukorgen visar senast tillagda forst
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { location.href = (location.pathname.indexOf('/sv/') === 0 ? '/sv' : '') + '/cart'; })
      .catch(function (err) {
        busy = false; if (btn) btn.classList.remove('ms-busy');
        alert('Kunde inte lägga paketet i varukorgen' + (err && err.description ? ': ' + err.description : '') + '. Försök igen eller byt den del som saknas i lager.');
      });
  }
  form.addEventListener('submit', addToCart, true);
  if (btn) btn.addEventListener('click', addToCart, true);


  // ---------- API till 3D-vyn (assets/ms-rum3d.js) ----------
  window.MSSW = {
    parts: D.parts, info: info,
    state: function () {
      return { vid: curVid, pkg: pkg, total: total(), modified: modified(), available: allAvailable(),
        slots: slots.map(function (s) { var p = info[s.c], v = p && variantOf(p, s.v); return { id: s.id, add: !!s.add, c: s.c, q: s.q, v: s.v, oc: s.oc, ov: s.ov, oq: s.oq, title: p ? p.title + (p.variants.length > 1 && v ? ' – ' + v.title : '') : '', price: v ? v.price * s.q : null, image: p ? p.featured_image : '', available: !!(v && v.available), cat: D.parts[s.c].c }; }) };
    },
    candidates: candidates, kr: kr, img: img, cat: CAT,
    swap: function (i, c, v, q) { var s = slots[i], cat = D.parts[s.c].c; s.c = c; s.v = v; s.q = q; render(); return cat === 'matbord' ? chairHint() : null; },
    chairHint: chairHint,
    addChairs: function (n) { var ch = slotOf('matstol'); if (!ch) return; ch.q += Math.ceil(n / (D.parts[ch.c].pk || 1)); render(); },
    remChairs: function (n) { var ch = slotOf('matstol'); if (!ch) return; ch.q = Math.max(Math.ceil(origChairs() / (D.parts[ch.c].pk || 1)), ch.q - Math.floor(n / (D.parts[ch.c].pk || 1))); render(); },
    reset: function () { load(curVid); },
    info: function (c) { return info[c] || null; },
    remove: function (i) { slots.splice(i, 1); render(); },
    setQty: function (i, q) { if (slots[i]) { slots[i].q = Math.max(1, q); render(); } },
    categories: function () {
      var n = {}; Object.keys(D.parts).forEach(function (c) { var k = D.parts[c].c; n[k] = (n[k] || 0) + 1; });
      return Object.keys(CAT).filter(function (k) { return n[k]; }).map(function (k) { return { cat: k, label: CAT[k], n: n[k] }; });
    },
    items: function (cat) {
      var codes = Object.keys(D.parts).filter(function (c) { return D.parts[c].c === cat && !slots.some(function (o) { return o.c === c; }); });
      return Promise.all(codes.map(function (c) { return prod(c).then(function (p) { info[c] = p; return c; }, function () { return null; }); })).then(function () {
        var list = [];
        codes.forEach(function (c) {
          var p = info[c]; if (!p) return;
          p.variants.forEach(function (v) {
            if (!v.available) return;
            var q = cat === 'matstol' ? Math.ceil(4 / (D.parts[c].pk || 1)) : 1;
            list.push({ c: c, v: v, q: q, p: p, price: v.price * q });
          });
        });
        list.sort(function (a, b) { return a.price - b.price; });
        return list;
      });
    },
    add: function (c, v, q) { slots.push({ id: 's' + (++sid), c: c, q: q, v: v, oc: c, oq: q, ov: v, add: true }); render(); return D.parts[c].c === 'matbord' ? chairHint() : null; },
    addToCart: addToCart,
    on: function (f) { listeners.push(f); }
  };
  function chairHint() {
    var ch = slotOf('matstol'), tb = slotOf('matbord'); if (!ch || !tb) return null;
    var need = chairsFor(D.parts[tb.c].L), have = chairCount(ch), min = origChairs();
    if (need > have) return { add: need - have, need: need, have: have };
    if (need < have && have > min) return { rem: have - Math.max(need, min), need: need, have: have };
    return null;
  }

  // ---------- variantbyte ----------
  function tick() {
    var v = vidInput && vidInput.value;
    if (v && v !== curVid) load(v);
    else renderPrice();
  }
  tick(); setInterval(tick, 400);
})();
